export const LINK_TYPE_NONE = 'LINK_NONE';
export const LINK_TYPE_INTERNAL = 'LINK_INTERNAL';
export const LINK_TYPE_EXTERNAL = 'LINK_EXTERNAL';
export const LINK_TYPE_EMAIL = 'LINK_EMAIL';

export const getLinkType = (hyperlink) => {
  const defaultLinkType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : LINK_TYPE_NONE;

  if (hyperlink === '') {
    return defaultLinkType;
  } else if (hyperlink === false) {
    return LINK_TYPE_INTERNAL;
  } else if (hyperlink.indexOf('/') === 0) {
    return LINK_TYPE_INTERNAL;
  } else if (hyperlink.indexOf('@') !== -1) {
    return LINK_TYPE_EMAIL;
  }

  return LINK_TYPE_EXTERNAL;
};



// WEBPACK FOOTER //
// ./src/tools/editor.js